const id = 'accountStates'

export default id
